/** Alert `status` values — Kintsugi Design System node 193:1159. */
export const alertStatuses = ['info', 'warning', 'success', 'error'] as const;

export type AlertStatus = (typeof alertStatuses)[number];

/** Leading status icon size (Figma `size-[20px]`). */
export const alertIconSizePx = 20;
